import {IconSize} from '@Components/icon-v2/icon.types';
import {AiPromptBoxSize} from '@Components/ai-prompt-box/ai-prompt-box.types';
import actionButtonStyles from '../../ai-prompt-box-action-button.module.scss';

export interface FooterSelectorIconTriggerSizing {
  triggerClass: string;
  iconSize: IconSize;
}

const smallIconTriggerSizing: FooterSelectorIconTriggerSizing = {
  triggerClass: actionButtonStyles.actionButtonSmall,
  iconSize: IconSize.SIZE_ICON_16,
};

const iconTriggerSizingMap: Record<AiPromptBoxSize, FooterSelectorIconTriggerSizing> = {
  [AiPromptBoxSize.SMALL]: smallIconTriggerSizing,
  [AiPromptBoxSize.SMALL_EXTENDED]: smallIconTriggerSizing,
  [AiPromptBoxSize.SINGLE_LINE]: {...smallIconTriggerSizing, triggerClass: actionButtonStyles.actionButtonSingleLine},
  [AiPromptBoxSize.MEDIUM]: {
    triggerClass: actionButtonStyles.actionButtonMedium,
    iconSize: IconSize.SIZE_ICON_20,
  },
};

export const getFooterSelectorIconTriggerSizing = (promptBoxSize: AiPromptBoxSize): FooterSelectorIconTriggerSizing => {
  return iconTriggerSizingMap[promptBoxSize];
};
